module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2013 Mike Hawkins")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner without written permission except in the case of brief quotations embodied in critical articles or reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The SCOPE of Leadership Book Series")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("A Guide to Coaching Leaders to Lead as Coaches")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Others: Developing People")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Brown Books Publishing Group")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("16250 Knoll Trail Drive, Suite 205")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Dallas, Texas 75248")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.BrownBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.BrownBooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("(972) 381-0009")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("A New Era in Publishing™")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("e-ISBN 978-1-61254-122-8")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("LCCN 2013933530")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("For more information or to contact the author, please go to")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ScopeOfLeadership.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ScopeOfLeadership.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.AlpineLink.com",
      "target": "_blank"
    }
  }, [_vm._v("www.AlpineLink.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b44859a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/03-copy.vue
// module id = 66
// module chunks = 0